import React from "react";
import { Link } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiMapMarkerOutline, mdiPhoneOutline, mdiEmailOutline, mdiClockOutline } from "@mdi/js";
import Logo from "./Logo";
import { useSite } from "../theme/ThemeProvider";
import { services } from "../content/services";

const Footer = () => {
  const site = useSite();
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div>
            <Logo light />
            <p className="footer__about">
              30 yıllık tecrübeyle LPG dönüşüm, tank değişimi, bakım, motor yağı değişimi ve çeki demiri montajı.
              Kaytazdere / Altınova / Yalova.
            </p>
          </div>
          <div>
            <h4>Hizmetler</h4>
            <ul>
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={`/hizmetler/${s.slug}`}>{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4>Kurumsal</h4>
            <ul>
              <li><Link to="/hakkimizda">Hakkımızda</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/iletisim">İletişim</Link></li>
              <li><Link to="/#hesapla">Tasarruf Hesaplayıcı</Link></li>
            </ul>
          </div>
          <div>
            <h4>İletişim</h4>
            <ul className="footer__contact">
              <li>
                <Icon path={mdiMapMarkerOutline} />
                <span>
                  {site.address.line1}
                  <br />
                  {site.address.line2}
                </span>
              </li>
              <li>
                <Icon path={mdiPhoneOutline} />
                <a href={`tel:${site.phoneHref}`}>{site.phone}</a>
              </li>
              <li>
                <Icon path={mdiEmailOutline} />
                <a href={`mailto:${site.email}`}>{site.email}</a>
              </li>
              {site.hours.map((h) => (
                <li key={h.days}>
                  <Icon path={mdiClockOutline} />
                  <span>
                    {h.days}: {h.time}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <span>© {year} {site.name}. Tüm hakları saklıdır.</span>
          <span>
            <Link to="/admin">Yönetim</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
